import { RootState } from "@/redux/reducer/store";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

interface IProp{
    className?: string;
}

const CurrentUTCTime: React.FC<IProp> = (prop:IProp) => {
    const { className } = prop;
    // const currentTitleDate = "08-11-2025 12:00:01"; // Replace with actual date logic if needed
    const searchResult = useSelector((state: RootState) => state.lightningReducer.searchResult);
    const [currentTitleDate, setCurrentTitleDate] = useState("");

    useEffect(()=>{
        if(searchResult?.cachedTime){
            const tempDate = moment.utc(searchResult.cachedTime, "YYYY-MM-DDTHH:mm:ss")
                .utcOffset(-240)
                // .tz("America/New_York")
                .format("MM-DD-YYYY HH:mm:ss");
            setCurrentTitleDate(tempDate);
        }
    },[searchResult]);
    // useEffect(() => {
    //     const updateDateTime = () => {
    //     // 獲取當前 UTC 時間減 5 小時
    //         const date = new Date(Date.now() - 5 * 60 * 60 * 1000);

    //         // 手動構建格式 "MM-DD-YYYY HH:mm:ss"
    //         const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    //         const day = String(date.getUTCDate()).padStart(2, "0");
    //         const year = date.getUTCFullYear();
    //         const hours = String(date.getUTCHours()).padStart(2, "0");
    //         const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    //         const seconds = String(date.getUTCSeconds()).padStart(2, "0");

    //         const formattedDate = `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;

    //         setCurrentTitleDate(formattedDate);
    //     };

    //     updateDateTime();
    //     const interval = setInterval(updateDateTime, 1000);

    //     return () => clearInterval(interval);
    // }, []);

    return (
        <span className={className}>Last Updated: {currentTitleDate}</span>
    );
};

export default CurrentUTCTime;